<template>
    <div>
        <template v-for="(items, itemType) in visibleItems" :key="'item_' + itemId">
            <div v-for="(cartItem, itemId, index) in items"
                 class="cart__wrap">
                <div class="cart__device">
                    <div v-if="cartItem.THUMB"
                         class="cart__img">
                        <img :src="cartItem.THUMB.SRC" :alt="cartItem.TITLE">
                    </div>
                    <div class="cart__grow cart__stretch">
                        <div class="cart__row cart__main">
                            <div :data-element="$root.getDataElement('cart_device_' + itemType + '_title_' + index)"
                                 class="cart__grow">
                                {{ cartItem.TITLE }}
                                <br>
                                <!-- todo получение названия акции по ее ID-->
                                <div v-if="cartItem.DISCOUNT === '28'"
                                     class="cart__mt--sm cart__note cart__note--blue">
                                    Для пользователей Виртуальной АТС
                                </div>

                                <template v-for="(stickersBlock, index) in cartItem.STICKERS" :key="index">
                                    <div>
                                        <div v-for="(sticker, index) in stickersBlock"
                                             class="cart__mt--sm cart__note"
                                             :key="index"
                                             v-bind:style="{ backgroundColor: sticker.BGCOLOR, color: '#fff'}">
                                            {{ sticker.NAME }}
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div v-if="cartItem.PRICE < cartItem.PRICE_FULL"
                                 class="cart__right">
                                <div class="cart__price">
                                    <span :data-element="$root.getDataElement('cart_device_' + itemType + '_orange_unit_price_' + index)"
                                          class="cart__val cart__val--big cart__val--red">{{
                                            formatPrice(cartItem.PRICE * cartItem.QUANTITY)
                                        }}</span>
                                    <span class="cart__units cart__units--red"> руб.</span>
                                </div>
                                <div class="cart__price cart__price--strike">
                                    <span class="cart__val">{{
                                            formatPrice(cartItem.PRICE_FULL * cartItem.QUANTITY)
                                        }}</span>
                                    <span class="cart__units">руб.</span>
                                </div>
                            </div>
                            <div v-else
                                 class="cart__price">
                                <span class="cart__val cart__val--big"
                                      :data-element="$root.getDataElement('cart_device_' + itemType + '_orange_unit_price_' + index)">{{
                                        formatPrice(cartItem.PRICE * cartItem.QUANTITY)
                                    }}</span>
                                <span class="cart__units"> руб.</span>
                            </div>
                        </div>

                        <span v-if="cartItem.hasOwnProperty('ADDRESS')"
                              class="cart__row cart__main"
                              :data-element="$root.getDataElement('cart_device_' + itemType + '_address_' + index)"
                              v-html="'Адрес: ' + cartItem.ADDRESS">
                        </span>

                        <span v-if="cartItem.hasOwnProperty('OFFICE') && cartItem.OFFICE"
                              class="cart__row cart__main"
                              :data-element="$root.getDataElement('cart_device_' + itemType + '_office_' + index)"
                              v-html="'Офис: ' + cartItem.OFFICE">
                        </span>

                        <div v-if="cartItem.hasOwnProperty('NOTE')"
                             class="cart__row">
                            <span class="cart__grow">Примечание:</span>
                            <span :data-element="$root.getDataElement('**' + itemType + '_note_' + index)">
                                {{ cartItem.NOTE }}
                            </span>
                        </div>

                        <div v-if="!cartItem.hasOwnProperty('ADDRESS') && !cartItem.hasOwnProperty('NOTE')"
                             class="cart__centered">
                            <div v-if="itemType === 'equipment'" class="cart__icons cart__grow">
                                <button v-if="cartItem.CAN_DELETE"
                                        :data-tooltip="typeProps(itemType).removeTooltip"
                                        @click="removeItem(itemId, 'devices')"
                                        :data-element="$root.getDataElement('remove_cart_device_' + itemType + '_' + index)"
                                        class="cart__del">Удалить
                                </button>
                                <span v-if="cartItem.IS_FAVORITS"
                                      class="cart__fav cart__fav--active"
                                      @click="addLike(cartItem.ID, cartItem.PRODUCT_ID)">
                                  В избранном
                                </span>
                                <span v-else
                                      class="cart__fav"
                                      @click="addLike(cartItem.ID, cartItem.PRODUCT_ID)">
                              В избранное
                            </span>
                            </div>
                            <div v-if="itemType === 'equipment'"
                                 class="cart__right">
                                <div class="quant quant--sm">
                                    <button :disabled="cartItem.QUANTITY <= 1"
                                            :data-element="$root.getDataElement('cart_dec_device_quantity_' + itemType + '_' + index)"
                                            @click="changeQuantity(itemId, parseInt(cartItem.QUANTITY) - 1)"
                                            class="button button--md button--tonal quant__button quant__button--sm"
                                            :class="{' button--disabled': cartItem.QUANTITY <= 1}">
                                        <i class="ui ui-minus"></i>
                                    </button>
                                    <div class="input quant__input">
                                        <input @input="setQuantity(itemId, cartItem.QUANTITY)"
                                               :data-element="$root.getDataElement('cart_device_quantity_input_' + itemType + '_' + index)"
                                               v-model="cartItem.QUANTITY"
                                               maxlength="3"
                                               type="text"
                                               class="input__field input__field--compact input__field--md quant__field quant__field--sm">
                                    </div>
                                    <button :disabled="cartItem.QUANTITY >= 999"
                                            :data-element="$root.getDataElement('cart_inc_device_quantity_' + itemType + '_' + index)"
                                            @click="changeQuantity(itemId, parseInt(cartItem.QUANTITY) + 1)"
                                            class="button button--md button--tonal quant__button quant__button--sm">
                                        <i class="ui ui-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import CartBlock from './CartBlock.vue'

export default Object.assign({}, CartBlock, {name: 'CartDeviceBlock'})
</script>